
export default function () {
	//案件リンクに「どこのページ」「どのパーツ」「何番目のリンク」がわかるように。パラメータ追加
		//cvc = ページスラッグ
		//cvp = パーツ名-[count]
		//画像とテキストリンク　/link/
		//ボタン btn
		//案件ボックス大 itemBoxL
		//サイドバー sidebar
		function getAddParamURL($el, paramtxt) {
			var href = $el.getAttribute('href');
			if(href) {
				//パラメータのみ
				if(href.match(/\?/) && !href.match(/#/)) {
					return href+'&'+paramtxt;
				}
				//ハッシュのみ
				if(!href.match(/\?/) && href.match(/#/)) {
					var tmpHref = href.split('#');
					return tmpHref[0]+'?'+paramtxt+'#'+tmpHref[1];
				}
				//パラメータとハッシュあり
				if(href.match(/\?/) && href.match(/#/)) {
					var tmpHref = href.split('#');
					return tmpHref[0]+'&'+paramtxt+'#'+tmpHref[1];
				}
				//その他
					return href+'?'+paramtxt;
			}
		}
		var myPath = location.pathname;
				myPath = myPath.split('/');
		var mySlug;

		if(document.querySelector('.c-concept')) {
			mySlug = "top";
		} else {
			mySlug = myPath[myPath.length - 2];
		}
		var slugParamTxt = 'cvc='+mySlug+'&cvp=';
		//外部リンクのみ取得
		var mainArealink = document.querySelectorAll('.c-postbody a[href*="/link/"]');
		var sidebarlink = document.querySelectorAll('.l-page__sidebar a[href*="/link/"]');

		var mainCounter = {
			itemBox : 1,
			btn : 1,
			link : 1
		}

		var sidebarCounter = 1;
		var fixedBtnCounter = 1;

		[].forEach.call(sidebarlink, function(v,i) {
			v.setAttribute('href', getAddParamURL(v, slugParamTxt + 'sidebar-' + sidebarCounter));
			sidebarCounter += 1;
		});

		[].forEach.call(mainArealink, function(v,i) {
			var cvptxt = '';
			if(v.classList.contains('js-itemBox')) {
				cvptxt = 'itemBox-' + mainCounter['itemBox'];
				mainCounter['itemBox'] += 1;
			}
			else if(v.classList.contains('c-btn')) {
				cvptxt = 'btn-' + mainCounter['btn'];
				mainCounter['btn'] += 1;
			}
			else {
				cvptxt = 'link-' + mainCounter['link'];
				mainCounter['link'] += 1;
			}
			v.setAttribute('href', getAddParamURL(v, slugParamTxt + cvptxt))
		});
		
	}